export default __webpack_public_path__ + "static/media/ibua.29e329df.png";